@if (reservation) {
  <div class="row list-group p-b-8">
    @if (conflictedOrderItemsGrouped$ | async; as conflictedOrderItemsGrouped) {
      <ng-container
      *ngTemplateOutlet="conflictedOrderItemsTable; context:{ orderItemsGrouped: conflictedOrderItemsGrouped }"></ng-container>
    }
  </div>
  <div class="row list-group">
    @if (!isMobile) {
      <div class="header-bar row">
        <div class="col-3 subheading-02"></div>
        <div class="col-2 subheading-02">{{ ('Order_Table.Access_Group' | trans) }}</div>
        <div class="col-2 subheading-02">{{ ('Order_Table.Type' | trans) }}</div>
        <div class="col-2 subheading-02">{{ ('Order_Table.Note' | trans) }}</div>
        <div class="col-2 subheading-02">{{ ('Order_Table.Price' | trans) }}</div>
      </div>
    }
    @if (localReservation$ | async; as localReservation) {
      <ng-container
      *ngTemplateOutlet="groupedOrderItemsTable; context:{ orderItemsGrouped: localReservation.groupedOrderItems }"></ng-container>
    }
  </div>
} @else {
  <cm-indicator data-hide-label></cm-indicator>
}

<ng-template #conflictedOrderItemsTable let-orderItemsGrouped="orderItemsGrouped">
  @if (orderItemsGrouped.length) {
    <cm-inline-notification data-type="warning">
      <span slot="icon" class="cm-icon cm-icon-warning-open" aria-hidden="true"></span>
      <div slot="buttons">
        <cm-button
          [attr.data-label]="'Order_Item_Conflicts.Remove_Order_Items' | trans"
          data-button-style="primary"
          data-button-type="text"
        (click)="removeConflictedOrderItems(orderItemsGrouped)"></cm-button>
      </div>
      {{ 'Order_Item_Conflicts.Text' | trans }}
    </cm-inline-notification>

    @for (orderItemGroup of orderItemsGrouped; track orderItemGroup) {
      <div class="col-12 conflict-group">
        <div class="list-group-content">
          <div class="header-label row">{{ orderItemGroup.name }}</div>
        </div>
        <div class="row col-12">
          @for (orderItem of orderItemGroup.items; track orderItem) {
            <div class="row list-group-content col-12 d-flex flex-flow-column">
              <div>
                {{ orderItem.priceName }}
              </div>
              @if (orderItem.venueSectionName) {
                <div class="subtitle">{{ orderItem.venueSectionName }}</div>
                @if (getOrderItemReservationName(orderItem); as name) {
                  <div
                    class="subtitle">{{ name }}
                  </div>
                }
              }
            </div>
          }
        </div>
      </div>
    }
  }
</ng-template>

<ng-template #groupedOrderItemsTable let-orderItemsGrouped="orderItemsGrouped">
  @for (orderItemGroup of orderItemsGrouped; track orderItemGroup; let i = $index) {
    <div class="col-12 list-group-content row">
      <div class="header-label" [ngClass]="isMobile ? 'col-4' : 'col-3'">{{ orderItemGroup.name }}</div>
      @if (!isMobile) {
        <div class="col-2">
          <ng-container
            *ngTemplateOutlet="accessGroupHeaderTemplate; context:{orderItemGroup: orderItemGroup}">
          </ng-container>
        </div>
        <div class="col-2">
          <ng-container
            *ngTemplateOutlet="ticketTypeHeaderTemplate; context:{orderItemGroup: orderItemGroup}">
          </ng-container>
        </div>
        <div class="col-2"></div>
        <div class="col-2">
          <ng-container
            *ngTemplateOutlet="orderPriceHeaderTemplate; context:{orderItemGroup: orderItemGroup, index: i}">
          </ng-container>
        </div>
      }
      @if (isMobile) {
        <div class="col-2"></div>
        <div class="col-4"></div>
      }
    </div>
    @for (orderItem of orderItemGroup.items; track orderItem) {
      @defer (on viewport) {
      @if (!isLoading) {
        @if (isMobile) {
          <ng-container
                            *ngTemplateOutlet="mobileOrderItemRow;
                                        context:{orderItem: orderItem, orderItemGroup: orderItemGroup}">
          </ng-container>
        } @else {
          <ng-container
                            *ngTemplateOutlet="nonMobileOrderItemRow;
                                        context:{orderItem: orderItem, orderItemGroup: orderItemGroup}">
          </ng-container>
        }
      } @else {
        <div class="order-item-skeleton w-100 d-flex align-items-center justify-content-center">
          <div class="skeleton-loading"></div>
        </div>
      }
      } @placeholder {
      <div class="skeleton-loading"></div>
    }
  }
}
</ng-template>

<ng-template #mobileOrderItemRow let-orderItem="orderItem" let-orderItemGroup="orderItemGroup">
  <div class="row list-group-content">
    <div class="table-column col-4 row">
      <div class="col-12">
        {{ orderItem.priceName }}
      </div>
      @if (orderItem.venueSectionName) {
        <div class="col-12 subtitle">
          {{ orderItem.venueSectionName }}<br>
          {{ getOrderItemReservationName(orderItem) }}
        </div>
      }
    </div>
    <div class="table-column col-2">
    </div>
    <div class="table-column col-4">
      <ng-container
      *ngTemplateOutlet="itemPriceTemplate; context:{orderItem: orderItem}"></ng-container>
    </div>
    <div class="table-column col-2 actions">
      <cm-context-menu>
        <cm-option data-icon="edit" (click)="showDetailsFor(orderItem.id)"
        [attr.data-display]="('Order_Item.Show_Details' | trans)"></cm-option>

        <cm-option data-icon="delete"
          (click)="deleteOrderItem(orderItem)"
        [attr.data-display]="('Order_Item.Delete' | trans)"></cm-option>
      </cm-context-menu>
    </div>
  </div>
  @if (showDetailsItemId === orderItem.id) {
    <div class="row list-group-content no-border">
      <div class="col-6">
        {{ 'Order_Table.Access_Group' | trans }}
      </div>
      <div class="col-6">
        <ng-container
        *ngTemplateOutlet="accessGroupTemplate; context:{orderItem: orderItem}"></ng-container>
      </div>
    </div>
    <div class="row list-group-content no-border">
      <div class="col-6">
        {{ 'Order_Table.Type' | trans }}
      </div>
      <div class="col-6">
        <ng-container
        *ngTemplateOutlet="ticketTypeTemplate; context:{orderItem: orderItem, orderItemGroup: orderItemGroup}"></ng-container>
      </div>
    </div>
    <div class="row list-group-content no-border">
      <div class="col-6">
        {{ 'Order_Table.Note' | trans }}
      </div>
      <div class="col-6">
        <ng-container *ngTemplateOutlet="noteTemplate; context:{orderItem: orderItem}"></ng-container>
      </div>
    </div>
  }
</ng-template>

<ng-template #nonMobileOrderItemRow let-orderItem="orderItem" let-orderItemGroup="orderItemGroup">
  <div class="row list-group-content">
    <div class="col-3 row">
      <div class="col-12">
        {{ orderItem.priceName }}
      </div>
      @if (orderItem.venueSectionName) {
        <div class="col-12 subtitle">
          {{ orderItem.venueSectionName }}<br>
          {{ getOrderItemReservationName(orderItem) }}
        </div>
      }
    </div>
    <div class="col-2">
      <ng-container
      *ngTemplateOutlet="accessGroupTemplate; context:{orderItem: orderItem}"></ng-container>
    </div>
    <div class="col-2">
      <ng-container
      *ngTemplateOutlet="ticketTypeTemplate; context:{orderItem: orderItem, orderItemGroup: orderItemGroup}"></ng-container>
    </div>
    <div class="col-2">
      <ng-container *ngTemplateOutlet="noteTemplate; context:{orderItem: orderItem}"></ng-container>
    </div>
    <div class="col-2">
      <ng-container
      *ngTemplateOutlet="itemPriceTemplate; context:{orderItem: orderItem}"></ng-container>
    </div>
    <div class="col-1">
      <cm-button data-button-type="icon"
        data-button-style="secondary"
        data-icon="delete"
        [attr.data-label]="('Order_Item.Delete' | trans)"
        (click)="deleteOrderItem(orderItem)">
      </cm-button>
    </div>
  </div>
</ng-template>

<ng-template #noteTemplate let-orderItem="orderItem">
  <div class="form-group">
    <div class="form-input">
      <input type="text" name="orderItemNote" [placeholder]="('Order_Table.Ticket_Note' | trans)"
        id="orderItemNote" class="form-control"
        (change)="updateOrderItemNote(orderItem, $event.target.value)"
        [(ngModel)]="orderItem.note">
    </div>
  </div>
</ng-template>

<ng-template #orderPriceHeaderTemplate let-orderItemGroup="orderItemGroup" let-index="index">
  <div class="form-group">
    <div class="form-input">
      <input placeholder="{{('Order_Table.Price' | trans)}}"
        class="form-control f-w-200"
        currencyMask
        min="0.00"
        [ngModel]="null"
        (focusout)="updateOrderPrice($event, orderItemGroup.items, $event.target.value)">
    </div>
  </div>
</ng-template>

<ng-template #ticketTypeHeaderTemplate let-orderItemGroup="orderItemGroup">
  @if (getGroupOrderItemTypes(orderItemGroup.id); as orderItemTypes) {
    <div class="form-group">
      <div class="form-input">
        <select class="form-control" data-component="cm-select"
          (change)="updateOrderItemTypes($event, orderItemGroup, $event.target.value, orderItemGroup.items)">
          @if (orderItemTypes.length > 1) {
            <option>{{ ('Order_Table.Price_Type' | trans) }}</option>
          }
          @for (ticketType of orderItemTypes; track ticketType) {
            <option [value]="ticketType.id">
              {{ ticketType.name }}
            </option>
          }
        </select>
        <span></span>
      </div>
    </div>
  }
</ng-template>

<ng-template #ticketTypeTemplate let-orderItem="orderItem" let-orderItemGroup="orderItemGroup">
  @if (venueSectionOrderItemTypes.get(orderItemGroup.id)?.get(orderItem.venueSectionGroupId) ?? getOrderItemTypes(orderItemGroup.id); as orderItemTypes) {
    <div class="form-group"
      >
      <div class="form-input">
        <select class="form-control f-w-200"
          data-component="cm-select"
          [ngModel]="orderItem.typeId"
          (change)="updateOrderItemTypes(null, orderItemGroup, $event.target.value, [orderItem])">
          @for (type of orderItemTypes; track type) {
            <option [value]="type.id">
              {{ type.name }}
            </option>
          }
        </select>
        <span></span>
      </div>
    </div>
  }
</ng-template>

<ng-template #accessGroupTemplate let-orderItem="orderItem">
  @if (getVenue(orderItem.venueId); as venue;) {
    <div class="form-group">
      <div class="form-input">
        <select class="form-control f-w-200"
          [ngModel]="orderItem.venueSectionAccessId"
          (change)="updateOrderItemsVenueSectionAccessId($event.target.value, [orderItem])"
          data-component="cm-select">
          <option value="">{{ ('Order_Table.No_Access_Group' | trans) }}
          </option>
          <ng-container>
            @for (section of venue.sections; track section) {
              <option disabled>{{ section.name }}</option>
              @for (venueSection of section.sections; track venueSection) {
                <option
                  [value]="venueSection.id">{{ venueSection.name }}
                </option>
              }
            }
          </ng-container>
          @for (venueSection of venueSections; track venueSection) {
            <option
              [value]="venueSection.id">{{ venueSection.name }}
            </option>
          }
        </select>
        <span></span>
      </div>
    </div>
  }
</ng-template>

<ng-template #accessGroupHeaderTemplate let-orderItemGroup="orderItemGroup">
  @if (getVenue(orderItemGroup.venueId); as venue;) {
    <div class="form-group">
      <div class="form-input">
        <select class="form-control"
          (change)="updateOrderItemsVenueSectionAccessId($event.target.value, orderItemGroup.items)"
          data-component="cm-select">
          <option value="">{{ ('Order_Table.Access_Group' | trans) }}
          </option>
          <ng-container>
            @for (section of venue.sections; track section) {
              <option disabled>{{ section.name }}</option>
              @for (venueSection of section.sections; track venueSection) {
                <option
                  [value]="venueSection.id">{{ venueSection.name }}
                </option>
              }
            }
          </ng-container>
          @for (venueSection of venueSections; track venueSection) {
            <option
              [value]="venueSection.id">{{ venueSection.name }}
            </option>
          }
        </select>
        <span></span>
      </div>
    </div>
  }
</ng-template>

<ng-template #itemPriceTemplate let-orderItem="orderItem">
  <div class="form-group">
    <div class="form-input">
      <input placeholder="{{('Order_Table.Price' | trans)}}"
        class="form-control f-w-200"
        currencyMask
        min="0.00"
        [(ngModel)]="orderItem.price">
    </div>
  </div>
  @for (costItemAgreement of orderItem.additionalCosts; track costItemAgreement) {
    @if (costItemAgreement.amount > 0) {
      <div class="order-item-cost-item-agreement">
        {{ costItemAgreement.label }}: {{ costItemAgreement.amount | currency }}
      </div>
    }
  }
</ng-template>


<ng-template #loadingSmall>
  <cm-indicator class="small" data-hide-label></cm-indicator>
</ng-template>
